export default (o, c, d) => {
  c.prototype.isTomorrow = function () {
    const tomorrow = window.dayjs.tomorrow()
    return this.isSame(tomorrow, 'date')
  }
}
